import { withStyles } from "@mui/styles";
import Tooltip from "@mui/material/Tooltip";

export {
  ValidationIcon,
  PasswordRequirements,
  WhiteTooltip,
  getUserTypeOptions,
  defaultTimezoneOptions,
  selectMe,
} from "../../Users/addUserForm/FormHelpers";

export const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}))(Tooltip);
